export enum AuctionControlButtonTrigger {
    LOOKER_TRIGGER = '',
    SELLER_TRIGGER = 'gtm-sell-trigger',
    BUYER_TRIGGER = 'gtm-make-bid',
    NO_TRIGGER = ''
}
